import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_COMMITTEEREGULARINVITEE_LOAD,
    ACTION_COMMITTEEREGULARINVITEE_LOAD_BY_ID,
    ACTION_COMMITTEEREGULARINVITEE_LOAD_BY_COMMITTEE_ID,

    ACTION_COMMITTEEREGULARINVITEE_SAVE,

    ACTION_COMMITTEEREGULARINVITEE_CREATE,

    ACTION_COMMITTEEREGULARINVITEE_VALIDATE,

    ICommitteeRegularInviteeLoadAction,
    ICommitteeRegularInviteeLoadByIdAction,
    ICommitteeRegularInviteeLoadByCommitteeIdAction,
    ICommitteeRegularInviteeLoadFailureAction,
    ICommitteeRegularInviteeLoadSuccessAction,

    ICommitteeRegularInviteeSaveAction,
    ICommitteeRegularInviteeSaveSuccessAction,
    ICommitteeRegularInviteeSaveFailureAction,

    ICommitteeRegularInviteeCreateAction,
    ICommitteeRegularInviteeCreateSuccessAction,
    ICommitteeRegularInviteeCreateFailureAction,

    ICommitteeRegularInviteeValidateAction,
    ICommitteeRegularInviteeValidateSuccessAction,
    ICommitteeRegularInviteeValidateFailureAction,

    LoadSuccess,
    LoadFailure,


    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/committeeRegularInvitee";
import { committeeRegularInviteesApi } from "../services/committeeRegularInvitees";


export const
    getCommitteeRegularInviteesEpic = (action$): Observable<ICommitteeRegularInviteeLoadSuccessAction | ICommitteeRegularInviteeLoadFailureAction> => {
        return action$
            .ofType(ACTION_COMMITTEEREGULARINVITEE_LOAD)
            .mergeMap((action: ICommitteeRegularInviteeLoadAction) => {
                return committeeRegularInviteesApi
                    .getCommitteeRegularInvitees(action.committeeId)
                    .map(response =>
                        LoadSuccess(response.committeeRegularInvitees, undefined, [], response.lookups, undefined)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getCommitteeRegularInviteesByIdEpic = (action$): Observable<ICommitteeRegularInviteeLoadSuccessAction | ICommitteeRegularInviteeLoadFailureAction> => {
        return action$
            .ofType(ACTION_COMMITTEEREGULARINVITEE_LOAD_BY_ID)
            .mergeMap((action: ICommitteeRegularInviteeLoadByIdAction) => {
                return committeeRegularInviteesApi
                    .getCommitteeRegularInviteeById(action.id)
                    .map(response =>
                        LoadSuccess(response.committeeRegularInvitee, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getCommitteeRegularInviteesByCommitteeIdEpic = (action$): Observable<ICommitteeRegularInviteeLoadSuccessAction | ICommitteeRegularInviteeLoadFailureAction> => {
        return action$
            .ofType(ACTION_COMMITTEEREGULARINVITEE_LOAD_BY_COMMITTEE_ID)
            .mergeMap((action: ICommitteeRegularInviteeLoadByCommitteeIdAction) => {
                return committeeRegularInviteesApi
                    .getCommitteeRegularInviteeByCommitteeId(action.committeeId)
                    .map(response =>
                        LoadSuccess(response.committeeRegularInvitees, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setCommitteeRegularInviteeEpic = (action$): Observable<ICommitteeRegularInviteeSaveSuccessAction | ICommitteeRegularInviteeSaveFailureAction> => {
        return action$
            .ofType(ACTION_COMMITTEEREGULARINVITEE_SAVE)
            .mergeMap((action: ICommitteeRegularInviteeSaveAction) => {
                return committeeRegularInviteesApi
                    .setCommitteeRegularInvitee(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.committeeRegularInvitee, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createCommitteeRegularInviteeEpic = (action$): Observable<ICommitteeRegularInviteeCreateSuccessAction | ICommitteeRegularInviteeCreateFailureAction> => {
        return action$
            .ofType(ACTION_COMMITTEEREGULARINVITEE_CREATE)
            .mergeMap((action: ICommitteeRegularInviteeCreateAction) => {
                return committeeRegularInviteesApi
                    .createCommitteeRegularInvitee(action.committeeId)
                    .map(response =>
                        CreateSuccess(response.committeeRegularInvitee, response.formState, response.formProperties, response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateCommitteeRegularInviteeEpic = (action$): Observable<ICommitteeRegularInviteeValidateSuccessAction | ICommitteeRegularInviteeValidateFailureAction> => {
        return action$
            .ofType(ACTION_COMMITTEEREGULARINVITEE_VALIDATE)
            .mergeMap((action: ICommitteeRegularInviteeValidateAction) => {
                return committeeRegularInviteesApi
                    .validateCommitteeRegularInvitee(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.committeeRegularInvitee, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }